var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineTrim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 31.808 27.752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.011041 6.4805c-0.09935-0.8225 0.48282-1.5979 1.3003-1.732l3.6032-0.5911c0.8175-0.1341 1.5607 0.4239 1.6601 1.2464 0.0993 0.8224-0.48286 1.5978-1.3004 1.7319l-3.6032 0.5911c-0.8175 0.1341-1.5608-0.4239-1.6601-1.2463zm10.81-1.7733c-0.0994-0.82241 0.4828-1.5978 1.3003-1.732l7.2063-1.1822c0.8175-0.1341 1.5608 0.42391 1.6601 1.2464 0.0994 0.82245-0.4828 1.5979-1.3003 1.732l-7.2063 1.1822c-0.8175 0.1341-1.5608-0.4239-1.6601-1.2464zm14.413-2.3643c-0.0994-0.82245 0.4828-1.5979 1.3003-1.732l3.6032-0.59108c0.8175-0.13411 1.5607 0.4239 1.6601 1.2464 0.0993 0.82245-0.4828 1.5979-1.3003 1.732l-3.6032 0.59108c-0.8175 0.1341-1.5608-0.42391-1.6601-1.2464z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.3459 17.271v-7.4547l12.493-2c1.3245 3.2226 7.6168 2.44 8.9516 5.2779h-9.5704l0.3267 9.7847 1.4178 4.873h-3.1901c-4.006-3.2812-8.748-4.989-10.429-10.481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.353 15.295c-0.41617 0.05547-0.98269 0.63984-1.0449 0.69922-0.80577 0.76583-1.5611 2.725-2.1289 3.8945h-1.4902v2.873h1.4902c0.5678 1.1695 1.3231 3.1287 2.1289 3.8945 0.09957 0.095 1.4902 1.535 1.4902 0 0-1.2281-0.56766-2.9443-0.85156-3.8945h2.3418v-2.873h-2.3418c0.2839-0.9502 0.85156-2.6664 0.85156-3.8945 0-0.57562-0.19561-0.7325-0.44531-0.69922z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineTrim);
export default __webpack_public_path__ + "static/media/engine_trim.04264644f3ddc61fef71fb23c8a72a00.svg";
export { ForwardRef as ReactComponent };